const codes = [
    {
        'uuid': '1',
        'code': 'registrationLeezen',
        'name': '初次申請評估-里仁',
        'onePerson': true,
        'description': '',
    },
    {
        'uuid': '2',
        'code': 'registrationTseYue',
        'name': '初次申請評估-慈悅',
        'onePerson': true,
        'description': '',
    },
    {
        'uuid': '3',
        'code': 'supervisor',
        'name': '單位主管',
        'onePerson': true,
        'description': '',
    },
    {
        'uuid': '4',
        'code': 'marketTestManager',
        'name': '市抽管理員',
        'onePerson': true,
        'description': '',
    },
    {
        'uuid': '5',
        'code': 'projectManager',
        'name': '承辦人',
        'description': '',
    },
    {
        'uuid': '6',
        'code': 'secondReviewer',
        'name': '覆核員',
        'description': '',
    },
    {
        'uuid': '7',
        'code': 'firstReviewer',
        'name': '文審初核員',
        'description': '',
    },
    {
        'uuid': '8',
        'code': 'assigner',
        'name': '派查員',
        'description': '',
    },
    {
        'uuid': '9',
        'code': 'inspector',
        'name': '稽核員',
        'description': '',
    },
    {
        'uuid': '10',
        'code': 'reviewer',
        'name': '審查委員',
        'description': '',
    },
]

export default codes;